import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventS {
    loadAddToCard = new Subject<boolean>();
    loadAddToCardProducts = new Subject<boolean>();
    openLoginDialog = new Subject<boolean>();

    // register this subject to listen window resize events.

    constructor() {
    }

}
